import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from "@mui/material";
import {
  Apps,
  Apartment,
  DynamicFeed,
  Forum,
  MoreHoriz,
} from "@mui/icons-material";
import { useDeviceType } from "../Utils/useDeviceType";
import { getActiveMenuPath, getRouteConfig } from "./routeConfig";

const NAV_ITEMS = [
  { label: "Home", path: "/", icon: <Apps /> },
  { label: "Community", path: "/community", icon: <Apartment /> },
  { label: "Social", path: "/social", icon: <DynamicFeed /> },
  { label: "Chat", path: "/chats", icon: <Forum /> },
];

export default function MobileBottomNav({ onOpenMenu }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isMobile } = useDeviceType();

  if (!isMobile) return null;

  const routeInfo = getRouteConfig(location.pathname);
  if (routeInfo?.parent) return null;

  const activeMenuPath = getActiveMenuPath(location.pathname);
  const activeIndex = NAV_ITEMS.findIndex((item) => item.path === activeMenuPath);

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        borderTop: "1px solid",
        borderColor: "divider",
      }}
      elevation={8}
    >
      <BottomNavigation
        value={activeIndex >= 0 ? activeIndex : false}
        onChange={(_, newValue) => {
          if (newValue < NAV_ITEMS.length) {
            navigate(NAV_ITEMS[newValue].path);
          }
        }}
        showLabels
        sx={{
          height: 60,
          "& .MuiBottomNavigationAction-root": {
            minWidth: "auto",
            py: 0.5,
            color: "text.secondary",
            "&.Mui-selected": {
              color: "primary.main",
            },
          },
          "& .MuiBottomNavigationAction-label": {
            fontSize: "0.7rem",
            "&.Mui-selected": {
              fontSize: "0.75rem",
              fontWeight: 600,
            },
          },
        }}
      >
        {NAV_ITEMS.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
            showLabel
          />
        ))}
        <BottomNavigationAction
          label="More"
          icon={<MoreHoriz />}
          showLabel
          onClick={(e) => {
            e.stopPropagation();
            onOpenMenu?.();
          }}
        />
      </BottomNavigation>
    </Paper>
  );
}
